import Pagination from "./Pagination"

const ServerPaginationTable = ({
  loading,
  columns = [],
  data = [],
  error = false,
  errorMessage,
  disableFooter = false,
  pagination = {
    currentPage: 1,
    itemsPerPage: 100,
    totalItems: 0,
    totalPages: 0,
  },
  onNext = () => {},
  onPrevious = () => {},
}) => {
  return (
    <section className="antialiased text-gray-600 my-[2rem]">
      <div className="flex flex-col h-full">
        <div className="w-[100%] mx-auto bg-white rounded-lg border md:mt-0 xl:p-0 h-full">
          <div className="p-0">
            <div className="overflow-x-auto">
              <table className="table-auto w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    {columns.map((head, index) => (
                      <th
                        scope="col"
                        key={index}
                        className="py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900"
                        style={head.style || {}}
                      >
                        {head.name}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody className="text-sm divide-y divide-gray-100 ">
                  {!loading &&
                    data.map((celldata, index) => (
                      <tr key={index}>
                        {columns.map((headcell, hIndex) => (
                          <td className="whitespace-nowrap px-3 py-2 text-sm" key={hIndex}>
                            {headcell.cell
                              ? headcell.cell(celldata, index)
                              : celldata[headcell.selector]}
                          </td>
                        ))}
                      </tr>
                    ))}

                  {!loading && !error && data.length === 0 && (
                    <tr>
                      <td colSpan={columns.length} className="w-full">
                        <div className="flex items-center justify-center w-full my-5">
                          <div className="font-medium text-gray-800">No items</div>
                        </div>
                      </td>
                    </tr>
                  )}

                  {loading && !error && (
                    <tr>
                      <td colSpan={columns.length} className="w-full">
                        <div className="flex items-center justify-center w-full my-5">
                          <div className="w-8 h-8 border-4 border-dashed rounded-full animate-spin border-blue-700"></div>
                        </div>
                      </td>
                    </tr>
                  )}

                  {!loading && error && (
                    <tr>
                      <td colSpan={columns.length} className="w-full">
                        <div className="flex items-center justify-center w-full my-5">
                          <div
                            className="bg-red-100 rounded-md py-2 px-6 mb-4 text-base text-center text-red-700"
                            role="alert"
                          >
                            {errorMessage}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {!disableFooter && (
              <Pagination
                currentPage={pagination.currentPage}
                totalItems={pagination.totalItems}
                totalPages={pagination.totalPages}
                pageSize={pagination.itemsPerPage}
                onNext={onNext}
                onPrevious={onPrevious}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServerPaginationTable
